<template>
  <div class="home">
    <ui-navigation></ui-navigation>
    <br>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="box">
            <ui-sidebar></ui-sidebar>
            <div class="rightBox clearfix">
              <router-view></router-view>
<!--              <ui-center></ui-center>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Sidebar from '@/components/layout/Sidebar.vue';
  // import Center from '@/components/home/Center.vue';
  import Navigation from '@/components/layout/Navigation.vue';
	export default {
	  name: 'Home',
    components:{
      'ui-navigation': Navigation,
      'ui-sidebar': Sidebar
      // 'ui-center': Center
	  },
    created(){
    }
	}
</script>

<style scoped lang='less'>
	.home{
    .box{
      display: flex;
      div.rightBox{
        flex: 1;
        margin-left: 30px;
      }
    }
	}
  @media (max-width: 1200px) {
  }
  @media (max-width: 992px) {
    .home{
      .box{
        div.rightBox{
          margin-left: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue